import { Icon } from "@iconify/react";
import pieChart2Fill from "@iconify/icons-eva/pie-chart-2-fill";
import fileTextFill from "@iconify/icons-eva/file-text-fill";
import { filterGuestSidebar, isGuestMember } from "src/utils/guestMember";

const getIcon = (name) => {
  return <Icon icon={name} width={22} height={22} />;
};

const sidebarConfig = (navbarList, userInfo) => {
  let sidebarMenus = [];

  sidebarMenus.push({
    title: "dashboard",
    path: "/dashboard",
    icon: getIcon(pieChart2Fill),
  });

  sidebarMenus.push({
    title: "Chat",
    path: "/chat",
    icon: getIcon("mdi:chat"),
  });

  sidebarMenus.push({
    title: "Your Information",
    path: "/forms",
    icon: getIcon("heroicons-solid:information-circle"),
    info: parseInt(userInfo?.formcount),
  });

  sidebarMenus.push({
    title: "Programmes",
    path: "/programmes",
    icon: getIcon(fileTextFill),
  });

  sidebarMenus.push({
    title: "Videos Library",
    path: "/videos-library",
    icon: getIcon("ic:round-video-library"),
  });

  sidebarMenus.push({
    title: "Weight Tracker",
    path: "/weight-tracker",
    icon: getIcon("mdi:weight-lifter"),
  });

  sidebarMenus.push({
    title: "Journeys",
    path: "/trackers",
    icon: getIcon("mdi:map-marker-path"),
  });

  sidebarMenus.push({
    title: "calendar",
    path: "/calendar",
    icon: getIcon("uil:calender"),
  });

  sidebarMenus.push({
    title: "community feed",
    path: "/community-area",
    icon: getIcon("healthicons:group-discussion-meetingx3"),
  });

  sidebarMenus.push({
    title: "Helping videos",
    path: "/helping_videos_category",
    icon: getIcon("mingcute:video-fill"),
  });

  if (navbarList && navbarList?.booking_enable) {
    sidebarMenus.push({
      title: navbarList?.nav_title,
      path: "/redirect-page",
      icon: getIcon("ic:round-date-range"),
    });
  }

  sidebarMenus.push({
    title: "Support Ticket",
    path: "/support-ticket",
    icon: getIcon("ic:round-support-agent"),
  });

  // Journey guests (magic-link login) only see Dashboard + Journeys.
  if (isGuestMember(userInfo)) return filterGuestSidebar(sidebarMenus);

  return sidebarMenus;
};
export default sidebarConfig;
